import { render, staticRenderFns } from "./DialogTablePagination.vue?vue&type=template&id=29e4b2a2&lang=pug&"
import script from "./DialogTablePagination.vue?vue&type=script&lang=js&"
export * from "./DialogTablePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports